import {FC} from "react";
import {Text} from "../../ui-components/text.tsx";
import SettingsIcon from "../../assets/images/settings.svg";
import PauseIcon from "../../assets/images/pause.svg";
import PlayIcon from "../../assets/images/playLightIcon.svg";
import {BottomSheet} from "../../container/ModalSheet.tsx";
import {ToastContainer} from "react-toastify";
import {LightButton} from "../buttons/LightButton.tsx";
import {IsLoadingContainer} from "../../container/IsLoadingContainer.tsx";
import useLaunchCampaignModal from "../../hooks/campaigns/useLaunhCampaignModal.ts";
import {Heading} from "../../ui-components/heading.tsx";
import {Table, TableBody, TableCell, TableRow} from "../../ui-components/table.tsx";
import {Button} from "../../ui-components/button.tsx";
import {useTranslation} from "react-i18next";
import {formatTimeFromApi} from "../../dateUtils/dateUtils.ts";

export const LaunchCampaignModal: FC<{
    isOpen: boolean;
    modalId: string;
    onClose: () => void;
}> = ({
          isOpen,
          onClose,
          modalId
      }) => {
    const {
        isLoading, data, navigateToSettings, categoryTitle, changeCampaignStatus
    } = useLaunchCampaignModal({modalId})
    const {t} = useTranslation();
    const timeForPosts = data?.campaign_post_time_open && data?.campaign_post_time_close ? formatTimeFromApi(data?.campaign_post_time_open) + ' - ' + formatTimeFromApi(data?.campaign_post_time_close) : '-'

    return (
        <BottomSheet isOpen={isOpen} onClose={onClose}>
            <div className="w-full px-4 flex flex-col items-center relative overflow-hidden">
                <ToastContainer className={'ToastContainer'} containerId={'launch_modal'}
                                style={{top: "23px"}}/>
                <div className="w-10 h-0.5 bg-[var(--color-line)] my-2"></div>
                <IsLoadingContainer isLoading={isLoading}>
                    {
                        data
                            ? <div className={"w-full flex flex-col items-center pt-6 "}>
                                <Heading level={2}
                                         className={"!text-2xl !text-black text-center font-medium mb-4 max-w-[90%]"}>
                                    {t('pages.channelInfo.transferTrafficFilter.confirmModal.confirmState.title')}
                                </Heading>
                                <Text
                                    className={"!text-sm mb-6 text-[var(--color-secondary-2)] text-center inline-block max-w-[95%] opacity-60"}>
                                    {t('pages.channelInfo.transferTrafficFilter.confirmModal.confirmState.subTitle')}
                                </Text>
                                <div className={"w-full border border-[var(--btn-border-custom)] rounded-lg p-4 mb-6"}>
                                    <Heading level={3} className={"!text-lg text-[var(--text-color-dark)] font-bold mb-2"}>
                                        {t('pages.channelInfo.transferTrafficFilter.statisticsTable.title')}
                                    </Heading>
                                    <Table className="w-full table-fixed mb-2">
                                        <TableBody>
                                            <TableRow className="last:[&>td]:!border-none">
                                                <TableCell
                                                    className="w-1/3 xs:!w-1/2 !text-sm !px-0 !pt-4.5 pb-2.5 text-[var(--color-secondary)] !border-b !border-[var(--btn-border-custom)] break-words whitespace-normal align-top">
                                                    {t('pages.channelInfo.transferTrafficFilter.statisticsTable.labels.mode')}
                                                </TableCell>
                                                <TableCell
                                                    className="w-2/3 xs:!w-1/2 !text-sm text-[var(--text-color-dark)] !px-0 !pt-4.5 pb-2.5 text-right !border-b !border-[var(--btn-border-custom)] break-words whitespace-normal align-top">
                                                    {data.campaign_mode === 'auto'
                                                        ? t('pages.channelInfo.transferTrafficFilter.statisticsTable.customValues.autoMode')
                                                        : t('pages.channelInfo.transferTrafficFilter.statisticsTable.customValues.manualMode')}
                                                </TableCell>
                                            </TableRow>
                                            <TableRow className="last:[&>td]:!border-none">
                                                <TableCell
                                                    className="w-1/3 xs:!w-1/2 !text-sm !px-0 !pt-4.5 pb-2.5 text-[var(--color-secondary)] !border-b !border-[var(--btn-border-custom)] break-words whitespace-normal align-top">
                                                    {t('pages.channelInfo.transferTrafficFilter.statisticsTable.labels.timeForPosts')}
                                                </TableCell>
                                                <TableCell
                                                    className="w-2/3 xs:!w-1/2 !text-sm text-[var(--text-color-dark)] !px-0 !pt-4.5 pb-2.5 text-right !border-b !border-[var(--btn-border-custom)] break-words whitespace-normal align-top">
                                                    {timeForPosts}
                                                </TableCell>
                                            </TableRow>
                                            <TableRow className="last:[&>td]:!border-none">
                                                <TableCell
                                                    className="w-1/3 xs:!w-1/2 !text-sm !px-0 !pt-4.5 pb-2.5 text-[var(--color-secondary)] !border-b !border-[var(--btn-border-custom)] break-words whitespace-normal align-top">
                                                    {t('pages.channelInfo.transferTrafficFilter.statisticsTable.labels.channelCategories')}
                                                </TableCell>
                                                <TableCell
                                                    className="w-2/3 xs:!w-1/2 !text-sm text-[var(--text-color-dark)] !px-0 !pt-4.5 pb-2.5 text-right !border-b !border-[var(--btn-border-custom)] break-words whitespace-normal align-top">
                                                    {categoryTitle}
                                                </TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                    <Button
                                        color={"white"}
                                        onClick={() => {
                                            onClose()
                                            navigateToSettings()
                                        }}
                                        className="w-full flex flex-row items-center !bg-white !text-sm !py-[7px] rounded-lg !border !border-[var(--btn-border-custom)] shadow-xs"
                                    >
                                        <SettingsIcon/> {t('common.buttons.tuneBtn')}
                                    </Button>
                                </div>
                                <div className={"w-full flex gap-4"}>
                                    <LightButton title={t('common.buttons.cancel')} onClick={onClose}/>
                                    <Button color={"dark/white"}
                                            type={'button'}
                                            onClick={changeCampaignStatus}
                                            className={"py-[10px] w-full flex items-center !text-sm !font-semibold !text-white rounded-lg box-shadow overflow-hidden"}>
                                        {
                                            data.status === 'disabled'
                                                ? <><PlayIcon/> {t('common.buttons.launchBtn')}</>
                                                : <><PauseIcon/> {t('common.buttons.stopBtn')}</>
                                        }
                                    </Button>
                                </div>
                            </div>
                            : ''
                    }
                </IsLoadingContainer>
            </div>
        </BottomSheet>
    );
};
